<template>
  <div>
    <el-dialog width="1200px" custom-class="quota-dialog" :visible.sync="dialogShow" @close="onDialogClose" :close-on-click-modal="false" append-to-body>
      <div slot="title" style="font-size: 21px;">{{ step == 1 ? '购买配额' : '支付中心' }}</div>
      <div v-if="step == 1" class="flex" style="height: 560px" v-loading="loading">
        <div class="bd pr-lg border-right">
          <div class="flex align-items-center justify-content-space-between mb-md">
            <div class="front-line front-title">购买数量</div>
            <el-input-number v-model="quota_num" :step="10" :min="10" :max="1000" step-strictly @change="changeQuotaNum"></el-input-number>
          </div>
          <el-progress :show-text="false" :percentage="quota_num / 10" :stroke-width="10" :status="'success'" class="quota-progress mb-md"></el-progress>
          <el-radio-group v-model="quota_num" @input="handleQuotaNum">
            <el-radio-button :label="10"></el-radio-button>
            <el-radio-button :label="20"></el-radio-button>
            <el-radio-button :label="50"></el-radio-button>
            <el-radio-button :label="100"></el-radio-button>
            <el-radio-button :label="200"></el-radio-button>
            <el-radio-button :label="500"></el-radio-button>
            <el-radio-button :label="1000"></el-radio-button>
          </el-radio-group>
          <div class="flex mb-md" style="margin-top: 40px;">
            <div class="front-line front-title">预充时长</div>
          </div>
          <div class="pre-purchase-time flex">
            <div
              class="pre-purchase-item flex column"
              v-for="(item,index) in precharge_options"
              :key="index"
              :class="{'active': index === activeIndex}"
              @click="selectMonth(item,index)"
            >
              <div class="bd flex justify-content-center align-items-center">
                <div class="flex column justify-content-space-around align-items-center price-area">
                  <div class="purchase_time">{{ item.precharge_month / 12 }}年</div>
                  <div class="purchase_price">￥{{ item.price || '--' }}</div>
                  <div class="purchase_origin_price">￥{{ item.market_price || '--' }}</div>
                </div>
              </div>
              <div class="ft discount-area">
                <div>{{ item.discount_rate && item.discount_rate < 1 ? '优惠后￥' + item.unit_price + '/年' : '无优惠' }}</div>
                <el-button v-if="index === activeIndex" class="check" type="warning" icon="el-icon-check" circle></el-button>
              </div>
              <div v-if="index === activeIndex" class="check-bg"></div>
              <div class="recommend" v-if="item.recommend">推荐</div>
            </div>
          </div>
          <div class="buy-tip" style="margin-top: 50px;">
            <div class="mb-xs">购买提示：</div>
            <div class="mb-xs">1、接入点单价与购买数量及预充时长有关，详细规则请联系工作人员；</div>
            <div class="mb-xs">2、已购买的接入点配额在创建接入点前，无有效期限制，可随时使用。</div>
          </div>
        </div>
        <div class="ft pl pr-lg pt-sm list-setting">
          <div class="flex align-items-center pb-md border-bottom">
            <div style="font-size: 21px;" class="text-black">配置清单</div>
          </div>
          <div class="configuration mt pb-sm border-bottom">
            <div class="flex justify-content-between align-items-center configuration-item">
              <div class="hd text-muted" style="width: 100px;">商品名称：</div>
              <div class="bd">{{ product_title }}</div>
            </div>
            <div class="flex justify-content-between align-items-center configuration-item">
              <div class="hd text-muted" style="width: 100px;">购买类型：</div>
              <div class="bd">新购订单</div>
            </div>
            <div class="flex justify-content-between align-items-center configuration-item">
              <div class="hd text-muted" style="width: 100px;">接入点数：</div>
              <div class="bd">{{ quota_num }}个</div>
            </div>
            <div class="flex justify-content-between align-items-center configuration-item">
              <div class="hd text-muted" style="width: 100px;">预充时长：</div>
              <div class="bd">{{ precharge_month / 12 }}年</div>
            </div>
            <div class="flex justify-content-between align-items-center configuration-item">
              <div class="hd text-muted" style="width: 100px;">总计金额：</div>
              <div class="bd text-success">￥{{ total_market_price }}</div>
            </div>
            <div v-if="discount_price" class="flex justify-content-between align-items-center configuration-item">
              <div class="hd text-muted" style="width: 100px;">优惠金额：</div>
              <div class="bd text-danger">-￥{{ discount_price }}</div>
            </div>
          </div>
          <div style="margin-top: 25px;" class="payable border-bottom">
            <div class="payable-title">应付金额：</div>
            <div class="payable-price text-success">￥{{ total_price }}</div>
          </div>

          <div class="foot-area flex column justify-content-center">
            <el-button @click="submit" :disabled="!precharge_month || !quota_num" class="submit-btn" type="success">立即下单</el-button>
            <div class="text-center mt-sm">
              付费即表示同意
              <a class="text-success" href="https://www.frippler.com/agreement/index.html" target="_blank">《云服务协议》</a>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="step == 2" v-loading="loading_pay" class="expense-order-part">
        <div class="order-desc mb-md flex">
          <span class="font-5x text-success hd">
            <i class="el-icon-info" />
          </span>
          <div class="bd">
            <div class="flex column" style="margin-left: 20px;">
              <f-count-down v-if="endTimestamp" :endtimestamp="endTimestamp" endtext="请尽快支付" class="font-lg text-danger" style="margin-top: 15px;" @finish="counterFinish" />
              <p>请您尽快完成付款，否则订单自动取消，库存产品发货顺序以付款时间为准</p>
            </div>
          </div>

          <div class="ft text-right flex column">
            <div class="mt-xs mb-sm">
              <span class="ml-sm">应付：</span>
              <span class="ml-sm font-2x text-danger">{{ order.order_amount_total | currency }}</span>
            </div>
            <span class="font-sm">{{ order.subject }}</span>
          </div>
        </div>
        <div v-if="blpay.enable">
          <div class="payment" style="border-bottom: 0;" @click="selectBl()">
            <el-checkbox v-model="use_bl" class="checkbox" />
            <img class="logo" src="../../../assets/bl.png" />
            <span class="title">余额支付</span>
            <div class="bank">
              <span>
                可用余额
                <span class="font-2x ml text-warning">{{ blpay.balance - blpay.balance_locked | currency }}</span>
              </span>
            </div>
            <div v-show="use_bl" class="pull-right amount">
              <span>抵扣：</span>
              <span
                v-if="blpay.balance - blpay.balance_locked < order.order_amount_total"
                class="text-danger font-lg"
              >{{ (blpay.balance - blpay.balance_locked) | currency }}</span>
              <span v-else class="text-danger">{{ order.order_amount_total | currency }}</span>
            </div>
          </div>
        </div>
        <div>
          <div v-if="wxpay.enable" class="payment" style="border-bottom: 0;" @click="selectWx()">
            <el-checkbox v-model="use_wx" class="checkbox" />
            <img class="logo" src="../../../assets/wxpay-logo.png" />
            <span class="title">微信支付</span>
            <div v-show="use_wx" class="pull-right amount">
              <span>应付：</span>
              <span class="text-danger font-lg">{{ wx_pay | currency }}</span>
            </div>
          </div>
          <div v-if="zzpay.enable" class="payment" @click="selectZz()">
            <el-checkbox v-model="use_zz" class="checkbox" />
            <img class="logo" src="../../../assets/boc-logo.png" />
            <span class="title">转账支付</span>
            <div class="bank">
              <span>开户银行：{{ zzpay.bank }}</span>
              <br />
              <span>银行账号：{{ zzpay.bank_account }} （{{ zzpay.corporate_name }}）</span>
            </div>
            <div v-show="use_zz" class="pull-right amount">
              <span>应付：</span>
              <span class="text-danger font-lg">{{ order.order_amount_total | currency }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="step == 2" slot="footer" class="text-center mb">
        <el-button class="extend" @click="back">返回</el-button>
        <el-button class="extend" type="primary" :disabled="!use_bl && !use_wx && !use_zz" @click="handlePay">立即支付</el-button>
      </div>
    </el-dialog>
    <el-dialog
      class="zzpay-dialog"
      width="900px"
      :visible.sync="zzpayShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="text-center">
        <div class="font-8x text-success">
          <i class="el-icon-circle-check" />
        </div>
        <div class="font-2x">请您按照如下信息进行转账汇款</div>
        <div class="font-lg text-left" style="display: inline-block;margin-top: 20px;">
          <p>
            <span>开户银行：</span>
            <span class="ml-sm text-danger">{{ zzpay.bank }}</span>
          </p>
          <p>
            <span>银行账号：</span>
            <span class="ml-sm text-danger">{{ zzpay.bank_account }}</span>
          </p>
          <p>
            <span>公司全称：</span>
            <span class="ml-sm text-danger">{{ zzpay.corporate_name }}</span>
          </p>
        </div>
        <div style="margin-top: 20px;">
          <el-button type="success" @click="toOrderList">返回订单列表</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      class="wxpay-dialog"
      width="900px"
      :visible.sync="wxpayShow"
      :close-on-click-modal="false"
      append-to-body
      @open="onWxpayOpen"
      @close="onWxpayClose"
    >
      <el-row v-show="!paySuccessConfirmed">
        <el-col :span="12" class="text-center">
          <div class="font-lg mb-sm">请使用微信扫描二维码支付</div>
          <QrcodeVue :value="codeUrl" :size="320" class="qrcode" />
          <div class="flex-center text-danger mt-sm mb-sm">
            <span class="font-lg">
              <i class="iconfont icon-clock"></i>
            </span>
            二维码有效期长为2小时，请尽快支付
          </div>
          <div>
            <el-button type="success" class="extend" @click="successRedirect">支付成功</el-button>
            <el-button type="info" plain @click="handleChange">其他支付方式</el-button>
          </div>
        </el-col>
        <el-col :span="12" class="text-center">
          <img src="../../../assets/wx-scan-guide.jpg" height="435px" />
        </el-col>
      </el-row>
      <div v-if="paySuccessConfirmed" class="text-center">
        <div class="font-8x text-success">
          <i class="el-icon-circle-check" />
        </div>
        <div class="font-2x">订单支付成功</div>
        <p>
          <span>即将返回</span>
          <span>
            （
            <f-count-down :diff="5" />）
          </span>
        </p>
      </div>
    </el-dialog>
  </div>
</template>
  
  <script>
import { calculatePayAmount, createQuotaOrder } from "@/api/ap/apApi";
import QrcodeVue from "qrcode.vue";
import { throttle } from '@/utils/common'
import FCountDown from "@/components/FCountDown";
import {
  enterCashierApi,
  payCashierApi,
  cancelOrderApi,
  checkCashierApi,
} from "@/api/expense/expenseOrderApi";

export default {
  components: {
    QrcodeVue,
    FCountDown
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    month: {
      type: Number,
      default: 12,
    },
  },
  data() {
    return {
      loading: false,
      quota_num: 10,
      precharge_options: [
        {
          precharge_month: 12,
          market_price: "",
          price: "",
          discount_rate: "",
        },
        {
          precharge_month: 24,
          market_price: "",
          price: "",
          discount_rate: "",
        },
        {
          precharge_month: 36,
          market_price: "",
          price: "",
          discount_rate: "",
        },
        {
          precharge_month: 48,
          market_price: "",
          price: "",
          discount_rate: "",
        },
        {
          precharge_month: 60,
          market_price: "",
          price: "",
          discount_rate: "",
        },
        {
          precharge_month: 72,
          market_price: "",
          price: "",
          discount_rate: "",
        },
      ],
      activeIndex: 0,

      discount_price: 0,
      total_market_price: 0,
      total_price: 0,
      precharge_month: 0,
      product_title: "",

      step: 1,
      orderid: "",
      use_bl: false,
      use_wx: false,
      use_zz: false,
      loading_pay: false,
      orderids: [],
      order: {},
      zzpay: {},
      wxpay: {},
      blpay: {},
      endTimestamp: 0,
      zzpayShow: false,
      wxpayShow: false,
      codeUrl: "",
      confirmPolling: null,
      paySuccessConfirmed: false,
      out_trade_no: "",
    };
  },
  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },

    wx_pay() {
      let num = 0;
      if (!this.use_bl) {
        num = this.order.order_amount_total;
      } else {
        if (
          this.blpay.balance - this.blpay.balance_locked <
          this.order.order_amount_total
        ) {
          num = (
            this.order.order_amount_total -
            (this.blpay.balance - this.blpay.balance_locked)
          ).toFixed(2);
        }
      }
      return num;
    },
    payment_type() {
      if (this.use_zz) {
        return 1;
      }
      if (this.use_wx) {
        return 2;
      }
      if (!this.use_wx && this.use_bl) {
        return 3;
      }
    },
    use_credit() {
      return this.use_wx && this.use_bl ? 1 : 0;
    },
  },
  created() {
    this.fetchData(true, true)
  },

  methods: {
    fetchData(loading, numChange) {
      if (loading ) this.loading = true;
      calculatePayAmount({
        num: this.quota_num,
        precharge_month: this.precharge_month,
      }).then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.precharge_options = res.data.precharge_options.map(
            (item, index) => {
              item.unit_price = item.price / (index + 1);
              item.recommend = item.recommend ? 1 : 0;
              return item;
            }
          );
          this.discount_price = res.data.discount_price;
          this.total_market_price = res.data.total_market_price;
          this.total_price = res.data.total_price;
          this.product_title = res.data.product_title;
          this.precharge_month = res.data.precharge_month;
          if(numChange) {
            this.activeIndex = this.precharge_options.findIndex(item => item.recommend);
            this.precharge_month = this.precharge_options[this.activeIndex].precharge_month;
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },

    changeQuotaNum(currentValue) {
      this.quota_num = currentValue > 10 ? Math.round(currentValue / 10) * 10 : 10;
      this.precharge_month = 0
      this.fetchData(true, true);
    },

    handleQuotaNum() {
      this.precharge_month = 0
      this.fetchData(true, true);
    },

    selectMonth(item, index) {
      this.activeIndex = index;
      this.precharge_month = item.precharge_month;
      this.fetchData(true, false);
    },

    submit: throttle(function () {
      const params = {
        num: this.quota_num,
        precharge_month: this.precharge_month,
      };
      createQuotaOrder(params).then((res) => {
        if (!res.errno) {
          this.orderid = res.data.orderid;
          this.step = 2;
          this.fetchOrderData();
        } else {
          this.$message.error(res.message);
        }
      });
    },500),

    // step 2
    fetchOrderData(loading) {
      if (loading) this.loading_pay = true;
      const orderids = [this.orderid];

      enterCashierApi({ orderids })
        .then((res) => {
          this.loading_pay = false;
          if (!res.errno) {
            this.order = Object.assign({}, res.data.order);
            this.zzpay = Object.assign({}, res.data.zzpay);
            this.wxpay = Object.assign({}, res.data.wxpay);
            this.blpay = Object.assign({}, res.data.blpay);
            this.endTimestamp = this.order.createtime + 2 * 3600;
          } else {
            this.$alert(res.message, "支付失败", {
              type: "error",
              confirmButtonText: "返回订单列表",
              callback: this.errorRedirect,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selectBl() {
      if (!this.use_bl) {
        this.use_bl = true;
        this.use_zz = false;
        this.use_wx = false;
      } else {
        this.use_bl = false;
      }
    },
    selectZz() {
      if (!this.use_zz) {
        this.use_zz = true;
        this.use_bl = false;
        this.use_wx = false;
      } else {
        this.use_zz = false;
      }
    },
    selectWx() {
      if (!this.use_wx) {
        this.use_wx = true;
        this.use_bl = false;
        this.use_zz = false;
      } else {
        this.use_wx = false;
      }
    },
    handlePay() {
      this.$confirm("", "确认立即支付？", {
        type: "warning",
        center: true,
      })
        .then(() => {
          const orderids = [this.orderid];
          payCashierApi({
            orderids,
            payment_type: this.payment_type,
            use_credit: this.use_credit,
          }).then((res) => {
            if (!res.errno) {
              // 操作成功处理
              this.out_trade_no = res.data.out_trade_no;
              if (this.payment_type === 1) {
                this.zzpayShow = true;
              }
              if (this.payment_type === 2) {
                this.codeUrl = res.data.code_url;
                this.wxpayShow = true;
              }
              if (this.payment_type === 3) {
                this.$confirm(
                  `订单总金额 <span class="font-lg text-warning">￥${this.order.order_amount_total}</span> ，全部使用余额支付。`,
                  "支付成功",
                  {
                    type: "success",
                    dangerouslyUseHTMLString: true,
                    showCancelButton: false,
                  }
                )
                  .then(() => {
                    this.successRedirect();
                  })
                  .catch(() => {
                    // 取消
                  });
              }
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          // 取消
        });
    },
    counterFinish() {

    },
    onWxpayOpen() {
      // 开始10秒定时器轮询查验是否支付成功
      this.confirmPolling = setInterval(() => {
        this.checkPayFinish();
      }, 10000);
    },
    onWxpayClose() {
      if (this.confirmPolling) {
        clearInterval(this.confirmPolling);
      }
    },
    checkPayFinish() {
      checkCashierApi({ out_trade_no: this.out_trade_no }).then((res) => {
        if (!res.errno) {
          // 确认支付已完成
          if (res.data.status == 1) {
            if (this.confirmPolling) {
              clearInterval(this.confirmPolling);
            }
            this.paySuccessConfirmed = true;
            setTimeout(() => {
              this.successRedirect();
            }, 5000);
          }
        } else {
          this.$message.error(res.message);
          this.zzpayShow = false;
          this.wxpayShow = false;
          if (this.confirmPolling) {
            clearInterval(this.confirmPolling);
          }
        }
      });
    },
    handleChange() {
      this.zzpayShow = false;
      this.wxpayShow = false;
      this.fetchOrderData();
    },
    successRedirect() {
      this.onDialogClose('paySuccess')
    },
    toOrderList() {
      this.$router.push("/expense/order");
    },
    errorRedirect() {
      this.$router.push('/expense/order')
    },
    back() {
      this.step = 1
      if(this.use_wx || !this.out_trade_no) {
        this.cancelOrder()
      }
      this.out_trade_no = ''
    },
    cancelOrder() {
      cancelOrderApi({ orderid: this.orderid }).then(res => {
        if (!res.errno) {
          this.zzpayShow = false
          this.wxpayShow = false
          this.orderid = ''
        } else {
          this.$message.error(res.message)
        }
      })
    },
    onDialogClose(status) {
      this.$emit("change",{refresh: true});
      this.$emit("update:show", false);
      if(this.use_wx || !this.out_trade_no) {
        if(this.orderid && status !== 'paySuccess') this.cancelOrder()
      }
    },
  },
};
</script>
  
<style lang="scss">
.el-dialog__wrapper > .el-dialog.quota-dialog {
  height: 680px;
  .el-dialog__body {
    padding-top: 20px;
    .el-progress.quota-progress {
      .el-progress-bar__outer {
        border-radius: 5px;
        background-color: #eef0f5;
      }

      .el-progress-bar__inner {
        border-radius: 5px;
      }
    }
  }
  .foot-area {
    margin-top: 50px;
    margin-left: 30px;
    margin-right: 30px;
    .submit-btn {
      width: 100%;
    }
  }
}
</style>

<style lang="scss" scoped>
.quota-dialog {
  .border-right {
    border-right: 1px solid #dcdfe6;
  }
  .border-bottom {
    border-bottom: 1px solid #dcdfe6;
  }
  .front-title {
    font-size: 16px;
    height: 32px;
    line-height: 32px;
  }
  .pre-purchase-time {
    .pre-purchase-item {
      width: calc((100% - 50px) / 6);
      height: 160px;
      box-sizing: border-box;
      border-radius: 5px;
      background-color: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
      margin: 0 5px;
      position: relative;
      cursor: pointer;
      &.active {
        border: 2px solid rgba(240, 173, 78, 1);
        .price-area {
          margin-top: -2px;
        }
        .discount-area {
          height: 40px;
        }
        .recommend {
          left: -2px;
          top: -15px;
        }
      }
      .price-area {
        height: 110px;
        .purchase_time {
          font-size: 14px;
        }
        .purchase_price {
          font-size: 28px;
        }
        .purchase_origin_price {
          font-size: 14px;
          text-decoration: line-through;
          color: rgba(144, 147, 153, 1);
        }
      }

      .discount-area {
        height: 42px;
        line-height: 40px;
        text-align: center;
        color: rgba(240, 173, 78, 1);
        background-color: rgba(240, 173, 78, 0.3);
        font-size: 12px;
        border-radius: 0 0 5px 5px;
        .check {
          position: absolute;
          z-index: 3;
          bottom: -2px;
          right: -2px;
        }
      }

      .check-bg {
        position: absolute;
        bottom: 0px;
        right: 0px;
        width: 40px;
        height: 40px;
        background-color: rgba(240, 173, 78, 1);
        z-index: 2;
        border-top-left-radius: 40px;
      }
    }

    .pre-purchase-item:first-child {
      margin-left: 0;
    }
    .pre-purchase-item:last-child {
      margin-right: 0;
    }

    .recommend {
      position: absolute;
      left: 0px;
      top: -13px;
      width: 60px;
      height: 24px;
      line-height: 24px;
      border-radius: 10px 10px 10px 0px;
      background: linear-gradient(
        91.06deg,
        rgba(254, 167, 44, 1) 3.04%,
        rgba(253, 120, 34, 1) 101.6%
      );
      color: rgba(255, 255, 255, 1);
      font-size: 11px;
      text-align: center;
    }
  }
  .buy-tip {
    font-size: 14px;
    color: #909399;
  }
  .list-setting {
    width: 380px;
    line-height: 1;
    height: 100%;
    position: relative;
    .configuration {
      .configuration-item {
        height: 40px;
        font-size: 14px;
      }
    }
    .payable {
      font-size: 14px;
      color: #909399;
      .payable-title {
        height: 40px;
        line-height: 40px;
        margin-bottom: 5px;
      }
      .payable-price {
        font-size: 36px;
        color: #07c160;
        margin-bottom: 10px;
        height: 40px;
        line-height: 40px;
      }
    }
  }
  .expense-order-part {
    padding: 0 10px;
    min-height: 480px;
    .order-desc {
      border-radius: 6px;
      background-color: rgba(238, 240, 245, 1);
      height: 100px;
      padding: 10px 20px 10px 30px;
    }
    .payment {
      height: 100px;
      padding: 20px 30px;
      padding-top: 30px;
      border: 1px solid #ebeef5;
      line-height: 40px;
      &:hover {
        background-color: #f5f7fa;
      }
      .logo {
        margin-left: 20px;
        height: 40px;
        width: 40px;
        vertical-align: middle;
      }
      .title {
        margin-left: 20px;
        font-size: 18px;
        display: inline-block;
        width: 160px;
        vertical-align: middle;
      }
      .bank {
        display: inline-block;
        line-height: 20px;
        vertical-align: middle;
      }
    }
  }
}
</style>
  

